@if (loaded) {
  <p-dialog
    [contentStyle]="{ overflow: 'auto' }"
    [styleClass]="'sm:col-12 md:col-6 lg:col-5 xl:col-4'"
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    (onHide)="close($event)"
    >
    <ng-template pTemplate="header">
      <span class="p-dialog-title">
        {{'Ver_Doc' | translate}}
      </span>
    </ng-template>
    <div class="col-12 p-field-radiobutton">
      <p-radioButton
        name="group1"
        value="origed"
        (onClick)="onClickOri()"
        [(ngModel)]="selectedVersionOri"
        inputId="opt1"
      ></p-radioButton>
      <label for="opt1" class="ml-2">{{'Ver_Exis' | translate}}</label>
    </div>
    <div class="col-12">
      <p-dropdown
        appendTo="body"
        [options]="versionList"
        [(ngModel)]="selectedVersion"
        optionLabel="name"
        [disabled]="versionListDisabled"
        placeholder="{{'Vers_Sel_1' | translate}}"
      ></p-dropdown>
    </div>
    <div class="col-12 p-field-radiobutton">
      <p-radioButton
        name="group1"
        value="orifil"
        (onClick)="onClickFile()"
        [(ngModel)]="selectedVersionOri"
        inputId="opt2"
      ></p-radioButton>
      <label for="opt2" class="ml-2">{{'Ver_File' | translate}}</label>
    </div>
    <div class="col-12">
      <p-fileUpload
        #fileUploader
        name="file"
        (onUpload)="onUpload($event)"
        (onError)="onError($event)"
        (onProgress)="onProgress($event, fileUploader)"
        (onBeforeUpload)="onBeforeUpload($event, fileUploader)"
        [multiple]="false"
        [showUploadButton]="false"
        [showCancelButton]="false"
        [chooseLabel]="browseLabel"
        [disabled]="versionFileDisabled"
        >
        <ng-template pTemplate="toolbar"> </ng-template>
        <ng-template let-file pTemplate="file">
          <!-- <table class="table head" style="font-size: 14px; width: 100%;">
          <thead>
            <tr>
              <th></th>
              <th width="50%">Fichier</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <img
                  *ngIf="file.type === 'image/jpeg' || file.type === 'image/png'"
                  class="innerimg"
                  width="50"
                  #img
                  [src]="file.objectURL"
                  />
                </td>
                <td class="fileTitle">{{ file.name }}</td>
                <td style="text-align: center">
                  <i
                    class="icons8-waste-basket margin-right iconstyle"
                    (click)="removeItem(file, fileUploader)"
                    style="color:red"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table> -->
          <div class="size_cent">
            @if (file.type === 'image/jpeg' || file.type === 'image/png') {
              <img
                class="innerimg"
                width="50"
                #img
                [src]="file.objectURL"
                />
            }
            {{ file.name }}
            <i
              class="icons8-trash-can margin-right iconstyle"
              (click)="removeItem(file, fileUploader)"
              style="color:red"
            ></i>
          </div>
        </ng-template>
        <ng-template pTemplate="content"> </ng-template>
      </p-fileUpload>
    </div>
    <ng-template pTemplate="footer">
      <button class="margin" pButton type="button" (click)="onClickValid(fileUploader)" label="{{'Valid' | translate}}"></button>
    </ng-template>
  </p-dialog>
}
